import React, { useEffect } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import cn from "classnames";
import { isValid } from "./../../../../helpers/functions";
import { Type } from "discover.medical.react-component-library";

export const BillingInformation = ({
  onFieldChange,
  billingFields,
  states,
  countries,
}) => {
  useEffect(() => {
    const selectsNodeList = document.querySelectorAll(
      ".billing-info .drop-down-select-container input",
    );
    for (let i = 0; i < selectsNodeList.length; i++) {
      selectsNodeList[i].setAttribute("autoComplete", "disabled");
    }
  }, []);

  const processFieldChange = (shouldSendRequest, type, value) => {
    let res = {};
    if (type === "billing-country") {
      res = {
        ...billingFields,
        [type]: {
          value: value.value,
          label: value.label,
          isValid: isValid(type, value.value),
        },
        "billing-state": {
          value: "",
          isValid: true,
        },
      };
    } else if (type === "billing-address-2") {
      res = {
        ...billingFields,
        [type]: {
          value: value,
          isValid: true,
        },
      };
    } else {
      res = {
        ...billingFields,
        [type]: {
          value: value,
          isValid: isValid(type, value),
        },
      };
    }
    onFieldChange(res, shouldSendRequest);
  };

  const handleInputChange = (e) => {
    e.persist();
    const ignoredFields = ["billing-first-name", "billing-last-name"];
    const shouldSendRequest = ignoredFields.indexOf(e.target.id) < 0;
    const { value } = e.target;
    const type = e.target.id;
    processFieldChange(shouldSendRequest, type, value);
  };

  const handleCountryChange = (selected) => {
    processFieldChange(true, "billing-country", selected);
  };

  const handleStateChange = ({ value }) => {
    processFieldChange(true, "billing-state", value);
  };

  const renderRequiredHint = (field) => {
    return (
      !billingFields[field].isValid && (
        <span className="form-group__required-field">*Required</span>
      )
    );
  };

  return (
    <div className="billing-info">
      <Type element="h2" styledAs="h4" fontFamily="secondary" marginBottom="sm">
        Billing Information
      </Type>
      <div className="form-group">
        <label htmlFor="billing-first-name">First Name</label>
        {renderRequiredHint("billing-first-name")}
        <input
          autoComplete="disabled"
          type="text"
          className={cn("form-control", {
            danger: !billingFields["billing-first-name"].isValid,
          })}
          id="billing-first-name"
          value={billingFields["billing-first-name"].value}
          onChange={handleInputChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="billing-last-name">Last Name</label>
        {renderRequiredHint("billing-last-name")}
        <input
          autoComplete="disabled"
          type="text"
          className={cn("form-control", {
            danger: !billingFields["billing-last-name"].isValid,
          })}
          id="billing-last-name"
          value={billingFields["billing-last-name"].value}
          onChange={handleInputChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="billing-address-1">Billing Address Line 1</label>
        {renderRequiredHint("billing-address-1")}
        <input
          autoComplete="disabled"
          type="text"
          className={cn("form-control", {
            danger: !billingFields["billing-address-1"].isValid,
          })}
          id="billing-address-1"
          value={billingFields["billing-address-1"].value}
          onChange={handleInputChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="billing-address-2">Billing Address Line 2</label>
        <input
          autoComplete="disabled"
          type="text"
          className="form-control"
          id="billing-address-2"
          value={billingFields["billing-address-2"].value}
          onChange={handleInputChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="billing-country">Country</label>
        <Select
          id="billing-country"
          placeholder=""
          value={{
            value: billingFields["billing-country"].value,
            label: billingFields["billing-country"].label,
          }}
          onChange={handleCountryChange}
          className="drop-down-select-container"
          classNamePrefix="drop-down-select"
          options={countries}
          inputProps={{ autoComplete: "disabled" }}
        />
      </div>
      <div className="form-group">
        <label htmlFor="billing-city">City</label>
        {renderRequiredHint("billing-city")}
        <input
          autoComplete="disabled"
          type="text"
          className={cn("form-control", {
            danger: !billingFields["billing-city"].isValid,
          })}
          id="billing-city"
          value={billingFields["billing-city"].value}
          onChange={handleInputChange}
        />
      </div>
      <div className="row">
        <div className="form-group col-md-9">
          <label htmlFor="billing-state">State/Province</label>
          {renderRequiredHint("billing-state")}
          {billingFields["billing-country"] &&
          billingFields["billing-country"].value === "US" ? (
            <Select
              id="billing-state"
              placeholder=""
              value={{
                value: billingFields["billing-state"].value,
                label: billingFields["billing-state"].value,
              }}
              onChange={handleStateChange}
              className={cn("drop-down-select-container", {
                danger: !billingFields["billing-state"].isValid,
              })}
              classNamePrefix="drop-down-select"
              options={states}
            />
          ) : (
            <input
              autoComplete="disabled"
              type="text"
              className={cn("form-control", {
                danger: !billingFields["billing-state"].isValid,
              })}
              id="billing-state"
              value={billingFields["billing-state"].value}
              onChange={handleInputChange}
            />
          )}
        </div>
        <div className="form-group col-md-3">
          <label htmlFor="billing-zip">
            Postal {billingFields["billing-zip"].isValid && "Code"}
          </label>
          {renderRequiredHint("billing-zip")}
          <input
            autoComplete="disabled"
            type="text"
            className={cn("form-control", {
              danger: !billingFields["billing-zip"].isValid,
            })}
            id="billing-zip"
            value={billingFields["billing-zip"].value}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ constants: { states, countries } }) => ({
  states,
  countries,
});

export default connect(mapStateToProps)(BillingInformation);
